import { NavigationService } from './../navigation.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-zip',
  templateUrl: './zip.component.html',
  styleUrls: ['./zip.component.scss']
})
export class ZipComponent implements OnInit {

  assets: string;
  zip: string;
  constructor(
    private nav: NavigationService,
    private router: Router,
  ) {
    this.assets = nav.assets;
    this.zip = null;
   }

  ngOnInit() {
    if (this.nav.attribution.success) {
      this.router.navigate(['thank']);
    }
  }

  savezip(event) {
    this.nav.updateState('zip', event);
  }

  onClick(){
    //this.nav.updateState('howOften', yesno);
    this.router.navigate(['/action', 'paper']);
  }

}
